export default {
  default_browser_tag: 'FoodAmigos - Commander en ligne',
  seo: {
    title: '{{name}} - commander en ligne à {{city}}',
    description: '{{name}} à {{city}}. Menu officiel. Économisez et commandez en ligne.',
  },
};
